import Item from "./item";
import List from "backdraft-app/src/listing/list";

export default class CustomDataList extends List {
  get itemClass() {
    return Item;
  }
}
